/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://6nmuefniwveivcgqk6ndujw47e.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-pdzs5tkgxnbf5dgpup4f6tmc3q",
    "aws_cloud_logic_custom": [
        {
            "name": "stripe",
            "endpoint": "https://ipn0vdy366.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        },
        {
            "name": "AdminQueries",
            "endpoint": "https://24chm2rxh0.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:6bcc767e-b517-4181-a154-347ed4e3260c",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_e67xoGdlQ",
    "aws_user_pools_web_client_id": "6v7jgt411o1qj0bal7sces96g",
    "oauth": {
        "domain": "petwalkercb4a99a8-cb4a99a8-dev.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://staging.lexination.com/,http://localhost:3344/,https://staging.lexination.com/",
        "redirectSignOut": "https://staging.lexination.com/,localhost:3344/,https://staging.lexination.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL",
        "PHONE_NUMBER"
    ],
    "aws_cognito_social_providers": [
        "FACEBOOK",
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "petwalker-20221202232400-hostingbucket-dev",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "http://petwalker-20221202232400-hostingbucket-dev.s3-website-us-east-1.amazonaws.com"
};


export default awsmobile;
